import React from 'react';
import { Mail, Phone } from 'lucide-react';

const getStatusColor = (status) => {
  switch (status) {
    case 'new':
      return 'bg-green-100 text-green-800';
    case 'contacted':
      return 'bg-blue-100 text-blue-800';
    case 'closed':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const ContactRow = ({ contact, onStatusChange }) => {
  return (
    <tr key={contact.id} className="hover:bg-gray-50" data-testid={`contact-row-${contact.id}`}>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">{contact.name}</div>
      </td>
      <td className="px-6 py-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <Mail className="w-4 h-4" />
            {contact.email}
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <Phone className="w-4 h-4" />
            {contact.phone}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-700">{contact.company || '-'}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-700 max-w-xs truncate">{contact.message}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <select
          value={contact.status}
          onChange={(e) => onStatusChange(contact.id, e.target.value)}
          data-testid={`contact-status-${contact.id}`}
          className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(contact.status)}`}
        >
          <option value="new">New</option>
          <option value="contacted">Contacted</option>
          <option value="closed">Closed</option>
        </select>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {new Date(contact.created_at).toLocaleDateString()}
      </td>
    </tr>
  );
};

export default ContactRow;
